<div class="orders-header__container">
  <ion-list-header class="orders-header">
    <ion-label class="orders-header__title">Orders ahead</ion-label>
    <!-- <ion-label class="orders-header__title">{{ queueInfo?.numPersonsAhead }} orders ahead</ion-label> -->
    <ion-button (click)="close()" class="cart-header__close-btn" fill="clear" color="dark">
      <svg
        slot="icon-only"
        class="orders-header__close-btn-icon"
        aria-label="Cart image"
      >
        <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
      </svg>
    </ion-button>
  </ion-list-header>
  <div class="divider"></div>
</div>
<ion-content class="container">
  <main *ngIf="!isLoadingStatuses; else spinner">
    <div
         *ngIf="!isEmptyOrders; else NoOrdersBlock"  class="container__content"
    >

      <div class="order-card__container">
        <app-order-status *ngFor="let orderStatus of ordersStatus" [orderStatus]="orderStatus" [isGroup]="isGroup"
                          [currencySign]="restaurantStore.restaurantCountryInfo.currencySign"></app-order-status>
      </div>
    </div>

    <div class="spinner-wrapper"
         *ngIf="isLoadingStatusesUpdate"
    >
      <app-spinner></app-spinner>
    </div>
  </main>
</ion-content>

<ng-template #NoOrdersBlock>
  <div class="container__content container__content--small">
    <p class="no-orders">
      No active orders! 😢
    </p>
  </div>
</ng-template>

<ng-template #spinner>
  <div class="spinner-wrapper">
    <app-spinner></app-spinner>
  </div>
</ng-template>
